import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function ssnValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const filtered = control.value.replace(/\D/g, '');
    return filtered.length === 9 ? null : { invalidSsn: true };
  };
}
